// Phone-event tracking, same two-leg pattern as akku-24/akkubolt:
// - a first-party server ping that is NOT consent-gated — it only feeds the
//   internal statistics table and the admin's call-source attribution (no
//   cookies, no third party). GET /api/phone_show hits this site's own
//   _ajax.php proxy; the API stamps visitor_session_info.phone_show_datetime
//   (+ the durable visitor_session_utm mirror) and fires the server-side GA
//   relay. Phone events are SERVER LEG ONLY — never add them to the /asosevent
//   client whitelist (2026-08-04 dedup; test_seo_funnel_durable enforces it).
// - a GA4 event on the site property (G-C2WWT9YJR0) gated on the TermsFeed
//   `tracking` consent level, using the network's Category_Action names.
//
// On this site the reveal moment is the design itself: the number exists
// NOWHERE until the „Hívás" pill is tapped, so Phone_Show is exactly the
// first tap and Phone_Call is the actual dial.
import apiClient from '../api/client'
import { gaTrackEvent as gaEvent } from './analytics'

// One reveal per page load — a second tap dials, it does not re-reveal.
let notified = false

export function notifyPhoneShow(): void {
	if (notified) return
	notified = true

	gaEvent('Phone_Show')

	// Fire-and-forget: a failed beacon must never block revealing the number.
	apiClient.get('/phone_show').catch(() => {})
}

/** A tel: link was tapped → the visitor is dialing. Every dial attempt is a
    distinct signal — no page-load guard. */
export function notifyPhoneCall(): void {
	gaEvent('Phone_Call')

	apiClient.post('/visitor_session', { phone_call: 1 }).catch(() => {})
}
